<template>
  <div id="page_company">
    <div class="banner">
      <img src="../assets/img/company_banner.jpg" alt="" class="bg">
      <div class="textbox">
        <h2 class="wow fadeInDown">Brotex Is A Leader In Acoustic Design Solutions</h2>
      </div>
    </div>
    <div id="part1" class="full">
      <img src="../assets/img/company_part1bg_m.jpg" alt="" class="bg">
      <div class="contentbox">
        <div class="mainTitle1 textbox white">
          <h3>Welcome To Brotex’s World</h3>
          <p>Every space engages and impacts our senses, you will first feel the sensory impact of the visual, and then the acoustical experience, so the quality of the sound board in many scenes are very necessary.</p>
          <p>As a leading supplier of environment-friendly acoustic materials, Brotex focuses on the production and customization of high-quality acoustic panels of various materials. Together with our high-quality team and leading technology, we will provide you with a feast of both visual and auditory effects and excellent service.</p>
          <br>
          <p>Every Brotex project benefits from our commitment to systematic research and development. We embrace leading manufacturing technologies and consistently open doors to new ways of working. When it comes to client interactions and project management, our curiosity and ingenuity allow us to act as true design partners, listening closely, exploring possibilities and adapting our processes accordingly.</p>
          <p>After all, Bortex speaks with its products.</p>
        </div>
      </div>
<!--      <div class="countbox">-->
<!--        <div class="item" v-for="(item,index) in countList" :key="index">-->
<!--          <countTo class="num" :startVal='item.start' :endVal='item.end' :duration='2000' separator=""></countTo>-->
<!--          <p>{{item.text}}</p>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div id="part2" class="full">
      <div class="mainTitle1 textbox white">
        <h3>Culture</h3>
        <i class="iconfont" :class="cultureList[cultureIndex].icon"></i>
<!--        <img :src="cultureList[cultureIndex].img" alt="">-->
        <h4>{{ cultureList[cultureIndex].title }}</h4>
        <p v-for="(item,index) in cultureList[cultureIndex].content" :key="index">{{item}}</p>
      </div>
      <div class="bottom">
        <div class="item" v-for="(item,index) in cultureList" :key="index" :class="index==cultureIndex?'active':''" @click="cultureIndex=index">{{item.btntitle}}</div>
      </div>
    </div>
    <div id="part3">
      <div class="mainTitle1 textbox">
        <h3>Founder Of Bortex</h3>
        <p>We set up Brotex to give you a more reliable choice for your acoustic solution.</p>
      </div>
      <div class="itembox">
        <div class="item" v-for="(item,index) in founderList" :key="index">
          <img :src="item.img" alt="">
          <div class="textbox">
            <p>{{item.desc}}</p>
            <h4>{{item.name}}</h4>
          </div>
        </div>
      </div>
    </div>
    <div id="part4" class="full">
      <div class="left">
        <div class="mainTitle1 textbox white">
          <h3>Our Certification</h3>
          <p>Certificates can not only prove our strength, but also bring customers security and trust.
            Brotex can offer an expansive library of sound attenuating products and accessory options. These utilize our sustainably sourced, 100% recyclable, lightweight and durable high-performance material. Brotex comes a wide range of colors and finishes, including wood textures, with available customization, to help you achieve the look you need while you build noise reduction into your spaces.</p>
        </div>
      </div>
      <div class="right">
        <swiper class="zsswp" ref="zsswp" :options="zhengshuOpt">
          <swiper-slide>
            <img src="../assets/img/首页-证书1.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页-证书2.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页-证书3.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页证书4.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate1.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate2.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate3.jpg" alt="">
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div id="part5">
      <div class="mainTitle1 textbox">
        <h3>Global Market</h3>
        <p>With years of experience, our acoustic perforated panels have been exported to many countries such as HK and Macao of China, America, Southeast Asia, etc. We have the ability to make your project effective.</p>
      </div>
      <div class="contentbox">
        <div class="left">
          <div class="item" v-for="(item,index) in progressList" :key="index">
            <h5>{{ item.name }}</h5>
            <el-progress :percentage="item.num" color="#FDA82B"></el-progress>
          </div>
        </div>
        <div class="right">
          <img src="../assets/img/company_map.png" alt="" class="map">
          <img src="../assets/img/company_point.png" alt="" class="point wow fadeInDown" :data-wow-delay="`${(index+1)*3/10}s`" v-for="(item,index) in progressList" :key="index" :style="{left:item.left,top:item.top}">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
// import countTo from 'vue-count-to';
export default {
  name: "Company",
  metaInfo:{
    title:'Guangdong Brotex Acoustic Technology Co.,Ltd | Company',
  },
  components:{
    // countTo,
  },
  data(){
    return{
      zhengshuOpt:{
        slidesPerView: 3,
        spaceBetween: 10,
      },
      countList:[
        {
          start:0,
          end:0,
          text:'Every space engages',
        },
        {
          start:0,
          end:0,
          text:'Every space engages',
        },
        {
          start:0,
          end:0,
          text:'Every space engages',
        },
        {
          start:0,
          end:0,
          text:'Every space engages',
        },
      ],
      cultureIndex:0,
      cultureList:[
        {
          img:require('../assets/img/company_part2icon1_m.png'),
          icon:'icon-shulvsehuanbao',
          title:'Environmental protection is an important step in our selection of materials.',
          btntitle:'We Strive To Be Green',
          content:['Bortex is a carbon-neutral company. Manufacturing in China and shipping products globally, we take significant steps to care for the world in which we live. We participate in programs that support reforestation, clean power, and environmental conservation. We are actively expanding our involvement in these global efforts, now and into the future.',],
        },
        {
          img:require('../assets/img/company_part2icon2_m.png'),
          icon:'icon-shiming',
          title:'Merging Design and Technology',
          btntitle:'Mission',
          content:['Mission of Brotex is to leverage cutting edge technology and software in combination with a deep understanding of design to push the boundaries of manufacturing. ',],
        },
        {
          img:require('../assets/img/company_part2icon3_m.png'),
          icon:'icon-weibiaoti-',
          title:'Our team is your team',
          btntitle:'Team Work',
          content:['Brotex\'s global team continues on themission, finding new ways to fuse design with novel technologies and methods to allow architectural products and custom manufacturing to take on new synergies. ',],
        },
        {
          img:require('../assets/img/company_part2icon4_m.png'),
          icon:'icon-jiazhiguan',
          title:'We value your values',
          btntitle:'Values',
          content:['Brotex leverages the advantages every day to deliver elegant and innovative client-driven sound design solutions that elevate and inspire the worlds where people live, work and play.',],
        },
      ],
      founderList:[
        {
          img:require('../assets/img/company_part3img1.jpg'),
          name:'Sally -- CEO',
          desc:'I am Sally, the CEO of BROTEX. I\'ve been specialized in the acustic industry  for more than 15 years.  Convince yourself of the unique Bortex quality. ',
        },
        {
          img:require('../assets/img/company_part3img2.jpg'),
          name:'Jenny -- Vice president',
          desc:'Hello,I\'m Jenny. I\'ve been working in here for 8 years. I have professional management knowledge and always get along well with my staffs in Brotex.',
        },
      ],
      progressList:[
        {
          name:'HK and Macao of CN',
          num:0,
          left:'2.7rem',
          top:'.5rem',
        },
        {
          name:'America',
          num:0,
          left:'.7rem',
          top:'.35rem',
        },
        {
          name:'Southeast Asia',
          num:0,
          left:'2.7rem',
          top:'.85rem',
        },
        {
          name:'The Middle East',
          num:0,
          left:'2.1rem',
          top:'.5rem',
        },
        {
          name:'Africa',
          num:0,
          left:'1.9rem',
          top:'.7rem',
        },
        {
          name:'Others',
          num:0,
          left:'.5rem',
          top:'.35rem',
        },
      ],
    }
  },
  created() {
    this.$emit('getnav',3)
  },
  mounted() {
    this.$nextTick(()=>{
      let wow = new WOW({
        live:false
      })
      wow.init()
      window.onscroll = ()=> {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTopo = document.documentElement.scrollTop || document.body.scrollTop;
        //变量windowHeight是可视区的高度
        // var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        // var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        //滚动条到底部的条件
        // console.log(scrollTopo)
        if (scrollTopo > 10) {
          this.countList[0].end = 1996;
          this.countList[1].end = 1996;
          this.countList[2].end = 1996;
          this.countList[3].end = 1996;
          // console.log("底部");
        }
        // console.log(scrollTopo)
        if (scrollTopo > 1800) {
          this.progressList[0].num = 30;
          this.progressList[1].num = 20;
          this.progressList[2].num = 20;
          this.progressList[3].num = 10;
          this.progressList[4].num = 10;
          this.progressList[5].num = 10;
          // console.log("底部");
        }
      };
    })
  }
}
</script>

<style lang="less" scoped>
#page_company{
  .banner{position: relative;z-index: 1;padding: 0.7rem 3%;text-align: center;overflow: hidden;
    .bg{position: absolute;bottom: 0;right: 0;z-index: -1;}
    .textbox{
      h2{color: white;}
    }
    .crumb{font: 20px Poppins-SemiBold;margin-top: 60px;
      a{color: white;
        &:not(:last-child):after{content: '>';margin: 0 20px;}
        &:last-child{border-bottom: 1px solid white;}
      }
    }
  }
  #part1{
    //background: url("../assets/img/company_part1bg.jpg") no-repeat 50% 50%/cover fixed;
    width: 100%;position: relative;padding: 0;
    .bg{width: 100%;height: 30vh;object-fit: cover;}
    .contentbox{padding: .3rem 3%;margin-top: -.8rem;position: relative;z-index: 3;
      .mainTitle1{background: #F1F1F1;padding: .3rem;padding-left: .1rem;margin-bottom: 0;
        h3{color: @main-c4;
          &:before{top: calc(50% - 0.03rem);}
        }
        p{width: 100%;color: @main-c4;}
      }
    }
    .countbox{display: flex;justify-content: space-between;text-align: center;color: white;
      .num{font: 60px/60px Poppins-SemiBold;}
      p{font: 16px Poppins-Regular;}
    }
  }
  #part2{background: url("../assets/img/company_part2bg.jpg") no-repeat 50% 50%;width: 100%;
    .textbox{margin: 0;
      &>*{padding:0 .2rem;}
      .iconfont{font-size: .34rem;margin: .5rem 0 .3rem;display: block;}
      img{margin: .5rem 0 .3rem;}
      h4{margin-bottom: 15px;}
      p{width: 100%;}
    }
    .bottom{display: flex;justify-content: space-between;margin-top: .3rem;flex-wrap: wrap;
      .item{width: calc(50% - .05rem);margin-bottom: .1rem;text-align: center;padding: .15rem 0;background: #F5F5F5;font: .14rem Poppins-SemiBold;cursor: pointer;color: @main-c4;
        &:hover,&.active{background: @main-c1;}
      }
    }
  }
  #part3{display: none;
    .itembox{flex-direction: column;
      .item{display: flex;width: 100%;align-items: center;justify-content: space-between;
        img{border-radius: 50%;width: .8rem;height: .8rem;}
        .textbox{width: 75%;
          p{margin-bottom: .1rem;}
        }
        &:not(:last-child){border-bottom: 1px solid #D7D8DB;padding-bottom: .2rem;margin-bottom: .2rem;}
      }
    }
  }
  #part4{background: @main-c4;display: flex;justify-content: space-between;align-items: center;position: relative;z-index: 1;flex-direction: column;
    //.wave3d{position: absolute;right: 0%;top: 0;width: 50%;height: 100%;z-index: -1;}
    .left{width: 100%;object-fit: cover;
      .mainTitle1{margin: 0;
        //h3:before{left: -8%;}
        p{width: 100%;}
      }
    }
    .right{justify-content: space-between;display: flex;margin-top: .2rem;width: 100%;
      img{width: calc(100%);}
    }
  }
  #part5{
    .contentbox{display: flex;align-items: center;flex-direction: column-reverse;
      .left{width: 100%;display: flex;flex-wrap: wrap;justify-content: space-between;
        .item{margin-bottom: .1rem;width: calc(50% - .05rem);
          /deep/ .el-progress{
            .el-progress-bar__outer{height: 12px!important;}
            //.el-progress__text{display: none;}
            .el-progress__text{margin-left:.15rem;}
          }
          p{color: @main-c4;font: 20px Helvetica-Bold;margin-top: 10px;}
        }
      }
      .right{position: relative;
        .map{width: 100%;}
        .point{position: absolute;width: .15rem;}
      }
    }
  }
}
</style>